














































import {Vue, Component, Ref, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ImportZonesItem} from "@/store/tarification/types";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import Swal from "sweetalert2";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {CollapseTransition,SelectWings}})
export default class importGenerals extends Vue {
  @PropSync('show') is_show!: boolean;
  @PropSync('blacklist_id') blacklistId!: number;
  @Ref('validator') validator: any;
  @Action("importBlackListGenerals") actionImport: any;
  @Action("actionLog") actionLog: any;
  @Getter delimiterList:any;

  private importRequest:ImportZonesItem = {
    name:undefined,
    file:undefined,
    delimiter:','
  };
  private logObject: ActionLog = {};

  onFileUpload (evt:any) {
    this.importRequest.file = evt[0]
  }

  get transport() {
    const channel = this.$route.params.channel;
    if (!channel) return '';
    return channel.replace(' ', '_').toLowerCase();
  }

  async importZones():Promise<void> {
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        let readPromise = new Promise<any>((resolve, reject) => {
          let fr = new FileReader();
          fr.onerror = reject;
          fr.onload = () => resolve(fr.result);
          fr.readAsText(this.importRequest.file);
        });
        let string = await readPromise;
        let object = {
          id: this.blacklistId,
          item: {
            name: this.importRequest.name,
            file: btoa(string),
            delimeter: this.importRequest.delimiter === 'space' ?  ' ' : this.importRequest.delimiter
          },
          channel: this.transport
        }
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Import",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams(object)
        }
        let response:any = await this.actionImport(object);
        await this.actionLog(this.logObject);
        await Swal.fire({
          type: 'success',
          title: <string> this.$t('import_success'),
          confirmButtonClass: "md-button md-success",
          html: `Загружено записей: ${response?.data?.recipients_count ?? 0}`,
          showConfirmButton: true
        });
      } catch (error) {
        this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
    }
  }
}
